import {
  GET_STARTED_BUTTON_TEXT,
  GOALS_TEXT,
  PURPOSE_TEXT,
  RESUME_BUTTON_TEXT,
} from './constants'

/** Maps ?modalId= query (1–4) to `currentPlanStep` used by handleModalClose / stepDataMap. */
export const planStepIndexFromModalQueryParam = modalId => {
  const n = Number(modalId)
  if (Number.isNaN(n) || n < 1 || n > 4) return null
  if (n === 4) return 3
  return n - 1
}

export const getModalButtonText = ({
  modalName,
  goalsIsInDraft,
  purposeIsInDraft,
}) => {
  if (modalName === GOALS_TEXT && goalsIsInDraft) {
    return RESUME_BUTTON_TEXT
  }
  if (modalName === PURPOSE_TEXT && purposeIsInDraft) {
    return RESUME_BUTTON_TEXT
  }
  return GET_STARTED_BUTTON_TEXT
}

export const getActiveStepFromCompletion = ({
  implementationApproachIsCompleted,
  goalsAreCompleted,
  purposeIsCompleted,
}) => {
  const stepConditions = [
    !implementationApproachIsCompleted,
    !goalsAreCompleted,
    !purposeIsCompleted,
  ]
  const newStep = stepConditions.findIndex(condition => condition)
  return newStep > 0 ? newStep : 0
}

export const findPlanPanel = panelData =>
  panelData?.find(({ header }) => header.toLowerCase().includes('plan'))

export const resolveSitePlaybookData = ({ playbookData, siteId }) =>
  playbookData?.find(site => site.site_id === siteId) || playbookData?.[0] || {}

export const hasProgramStartDatePassed = programStartDate => {
  if (!programStartDate) {
    return false
  }

  const start = new Date(programStartDate)
  start.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return today >= start
}

export const hasRecentActivitiesStartDatePassed = ({
  programStartDate,
  lessonCompletionGoalIsDisabled,
  classCreationGoalDate,
}) => {
  if (!lessonCompletionGoalIsDisabled && programStartDate) {
    return hasProgramStartDatePassed(programStartDate)
  }

  if (lessonCompletionGoalIsDisabled) {
    return hasProgramStartDatePassed(classCreationGoalDate)
  }

  return false
}

export const resolveAdminK8Site = ({ adminK8Sites, site, siteId }) => {
  if (site) {
    return site
  }

  if (siteId != null && adminK8Sites?.length) {
    const matchedSite = adminK8Sites.find(
      adminSite => String(adminSite.id) === String(siteId),
    )

    if (matchedSite) {
      return matchedSite
    }
  }

  return adminK8Sites?.[0] || {}
}
